import { firebaseDb, ServerTimestamp } from '../firebase/'
import { addNotification } from './notification'
import { reset } from 'redux-form';
import history from '../history'

export const loadReports = () => (
  dispatch => {
    firebaseDb.collection('reports').orderBy('created', 'desc').limit(20).onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_REPORTS',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err);
    })
  }
)
export const addReport = values => (
  dispatch => {
    firebaseDb.collection('reports').add({
      uid: values.uid,
      date: new Date(values.date.replace(/-/g, '/') + ' 00:00:00'),
      text: values.text,
      feeling: Number(values.feeling),
      created: ServerTimestamp
    })
    .then(() => {
      dispatch(reset('report'))
      dispatch(addNotification("送信しました", "success"))
      history.push('/')
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("送信に失敗しました", "error"))
    })
  }
)
export const deleteReport = id => (
  dispatch => {
    firebaseDb.collection('reports').doc(id).delete()
    .then(() => {
      dispatch(addNotification("削除しました", "success"))
    })
    .catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("削除に失敗しました", "error"))
    })
  }
)


// WEBPACK FOOTER //
// ./src/actions/reports.js